export const vaultKeys = {
  all: ["vault"] as const,
  folders: () => [...vaultKeys.all, "folder"] as const,
  folder: (id: string, authScope?: string | null) =>
    authScope == null
      ? ([...vaultKeys.folders(), id] as const)
      : ([...vaultKeys.folders(), id, authScope] as const),
  requirements: (folderId: string, authScope?: string | null) =>
    [...vaultKeys.folder(folderId, authScope), "requirements"] as const,
  requirement: (folderId: string, reqId: string, authScope?: string | null) =>
    [...vaultKeys.folder(folderId, authScope), "requirement", reqId] as const,
  files: (folderId: string, authScope?: string | null) =>
    [...vaultKeys.folder(folderId, authScope), "files"] as const,
  bdc: () => [...vaultKeys.all, "bdc"] as const,
  bdcStatus: (reqId: string, authScope?: string | null) =>
    authScope == null
      ? ([...vaultKeys.bdc(), "status", reqId] as const)
      : ([...vaultKeys.bdc(), "status", reqId, authScope] as const),
  bdcCompanyData: (reqId: string, authScope?: string | null) =>
    authScope == null
      ? ([...vaultKeys.bdc(), "company-data", reqId] as const)
      : ([...vaultKeys.bdc(), "company-data", reqId, authScope] as const),
  verification: () => [...vaultKeys.all, "verification"] as const,
  identityVerification: () =>
    [...vaultKeys.verification(), "identity"] as const,
  poaVerification: () =>
    [...vaultKeys.verification(), "proof-of-address"] as const,
};
